import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { ThemeMode, UiStore } from './ui-types';

export const useUiStore = create<UiStore>()(
  devtools(
    persist(
      (set) => ({
        theme: 'light' as ThemeMode,
        locale: 'en-US',
        isSidebarMinimized: false,
        setTheme: (theme) => set({ theme }),
        setLocale: (locale) => set({ locale }),
        setSidebarMinimized: (value) => set({ isSidebarMinimized: value }),
        toggleSidebarMinimized: () =>
          set((state) => ({ isSidebarMinimized: !state.isSidebarMinimized })),
      }),
      {
        name: 'ui-store',
        partialize: (state) => ({
          theme: state.theme,
          locale: state.locale,
          isSidebarMinimized: state.isSidebarMinimized,
        }),
      }
    )
  )
);
